<template>
  <v-dialog v-model="show" persistent max-width="800">
    <v-card>
      <v-card-title class="title white--text pl-1 py-2" :class="check.color">
        <!-- <div> -->
        <span class="ml-1 mr-2" v-if="check.sale_type != 5">#{{
          check.service_type == 3 ? check.table_name :
            check.check_number
        }}</span>
        <v-icon color="white" class="pl-1" :class="{ 'red': check.service_type === '3' }">{{ check.icon }}</v-icon>
        <sup class="caption">({{ check.total_items }})</sup>
        <!-- </div> -->
        <v-spacer></v-spacer>
        <span v-if="showTime">
          <timer :date="`${check.sale_open_date}`" :time="`${check.sale_open_time}`" v-show="!check.fab"
            v-if="check.sale_type != 5"></timer>
        </span>
      </v-card-title>
      <v-card-text class="pa-0 subheading font-weight-bold">
        <v-layout row wrap>
          <v-flex xs12 class="table-header">
            <v-layout row wrap class="pa-2">
              <v-flex xs1 text-xs-left>
                <strong>Status</strong>
              </v-flex>
              <v-flex xs1>
                <strong>Kot #</strong>
              </v-flex>
              <v-flex xs3>
                <strong>Items</strong>
              </v-flex>
              <v-flex xs1 text-xs-center>
                <strong>Quantity</strong>
              </v-flex>
              <v-flex xs2 text-xs-center>
                <strong>Kot Time</strong>
              </v-flex>
              <v-flex xs2 text-xs-center>
                <strong>Prepared</strong>
              </v-flex>
              <v-flex xs2 text-xs-right>
                <strong>At Kitchen</strong>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
          </v-flex>

          <template v-for="(item, k) in sortItems">
            <v-flex xs12 :key="`items--${k}`">
              <v-layout row wrap class="px-2 py-1">
                <v-flex xs1 text-xs-left class="px-2">
                  <v-icon v-if="item.status == 2" color="primary" class="pt-1">flaticon-item-fired</v-icon>
                  <v-icon v-if="item.status == 4" color="success">flaticon-item-prepared</v-icon>
                  <v-icon v-if="item.status == 6" color="orange">flaticon-checked</v-icon>
                  <v-icon v-if="item.status == 9" color="error">flaticon-void</v-icon>
                  <v-icon v-if="item.status == 3" color="orange">flaticon-item-accepted</v-icon>&nbsp;
                </v-flex>
                <v-flex xs1>{{ item.kot_number }}</v-flex>
                <v-flex xs3>{{ item.name }}</v-flex>
                <v-flex xs1 text-xs-center>{{ item.quantity }}</v-flex>
                <v-flex xs2 text-xs-center>{{ item.kot_sent_time }}</v-flex>
                <v-flex xs2 text-xs-center>{{ item.kot_ready_time }}</v-flex>
                <v-flex xs2 text-xs-right>
                  <div v-if="item.status == 4 || item.status == 6 || item.status == 9">-</div>
                  <timer v-else :date="`${check.sale_open_date}`" :time="`${item.kot_sent_time.slice(0, -3)}`"></timer>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 :key="`items-divider--${k}`">
              <v-divider ></v-divider>
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn block color="orange" flat>
          Accept&nbsp;
          <v-icon size="18">flaticon-item-accepted</v-icon>
        </v-btn>
        <v-btn block color="red" flat>
          Void&nbsp;
          <v-icon size="18">flaticon-void</v-icon>
        </v-btn>
        <v-btn block color="green" flat>
          Prepared&nbsp;
          <v-icon size="18">flaticon-item-prepared</v-icon>
        </v-btn>-->
        <v-spacer></v-spacer>
        <v-btn color="error" flat @click="$emit('close', false)">
          Close
          <!-- <v-icon>clear</v-icon> -->
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import timer from "@/components/utils/timer";

export default {
  components: {
    timer
  },
  props: {
    show: Boolean,
    check: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    showTime() {
      let show = this.$store.getters.nodeSettings;
      return show.showTime.value;
    },
    sortItems(){
      const items = this.check.items;
      const sort = Number(this.preference.sortOrder);

      return items.sort((a, b) => {
        const d1 = a.kot_number;
        const d2 = b.kot_number;
        if (d1 < d2) return sort * -1;
        if (d1 > d2) return sort;
        return 0;
      });
    },
    preference() {
      return this.$store.getters.getPreferences;
    },
  }
};
</script>

<style>
.table-header {
  background-color: #565656;
  border-color: #565656;
}
.theme--light .table-header {
  background-color: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
}
</style>